import { useState } from "react";
import { C } from "../lib/colors";
import { Logo } from "../components/Logo";
import { PasswordInput } from "../components/PasswordInput";
import { signIn, verifyMfaLogin } from "../lib/auth";
import { MinimalFooter } from "../components/MinimalFooter";

export const LoginPage = ({ onNavigate, onOwnerLogin, onClientLogin }) => {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);
  const [mfa, setMfa]           = useState(null); // { factorId } | null
  const [code, setCode]         = useState("");

  const completeLogin = (res) => {
    if (res.role === "owner")  { onOwnerLogin(); return true; }
    if (res.role === "client") { onClientLogin(res.client); return true; }
    setError("Unrecognised account type. Please contact support.");
    return false;
  };

  const handleLogin = async () => {
    setError(""); setLoading(true);
    try {
      const res = await signIn(email, password);
      if (res.mfaRequired) {
        setMfa({ factorId: res.factorId });
        setCode("");
        return;
      }
      completeLogin(res);
    } catch (err) {
      setError(err.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyMfa = async () => {
    const cleaned = code.replace(/\s/g, "");
    if (!/^\d{6}$/.test(cleaned)) {
      setError("Enter the 6-digit code from your authenticator app.");
      return;
    }
    setError(""); setLoading(true);
    try {
      const res = await verifyMfaLogin(mfa.factorId, cleaned);
      completeLogin(res);
    } catch (err) {
      setError(err.message || "Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  const cancelMfa = () => { setMfa(null); setCode(""); setError(""); };

  return (
    <div style={{minHeight:"100vh",background:"#000000",fontFamily:"'Instrument Sans',sans-serif",color:C.text,
      display:"flex",flexDirection:"column"}}>
      {/* NAV */}
      <nav style={{padding:"0 5%",height:96,display:"flex",alignItems:"center",justifyContent:"space-between",
        borderBottom:`1px solid ${C.border}`}}>
        <button onClick={()=>onNavigate("landing")} style={{background:"none",border:"none",cursor:"pointer"}}>
          <Logo size={44}/>
        </button>
        <button onClick={()=>onNavigate("landing")} style={{background:"none",border:"none",color:C.muted,
          fontSize:13,cursor:"pointer",fontFamily:"'Instrument Sans',sans-serif"}}>
          ← Back to Home
        </button>
      </nav>

      {/* FORM */}
      <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",padding:24,position:"relative"}}>
        <div style={{position:"absolute",top:"30%",left:"50%",transform:"translateX(-50%)",width:500,height:500,
          borderRadius:"50%",background:"radial-gradient(circle,rgba(0,240,160,0.05) 0%,transparent 70%)",pointerEvents:"none"}}/>

        <div style={{width:"100%",maxWidth:420,animation:"fadeUp 0.4s ease"}}>

          {mfa ? (
            <>
              <div style={{textAlign:"center",marginBottom:36}}>
                <div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",
                  width:56,height:56,borderRadius:16,background:`linear-gradient(135deg,${C.green},${C.blue})`,
                  fontSize:26,marginBottom:18}}>🔒</div>
                <h1 style={{fontFamily:"'Sora',sans-serif",fontSize:26,fontWeight:800,letterSpacing:-1,marginBottom:8}}>
                  Two-factor verification
                </h1>
                <p style={{color:C.muted,fontSize:14,lineHeight:1.6}}>
                  Open your authenticator app and enter the 6-digit code for <strong style={{color:C.green}}>Media on Auto Pilot</strong>.
                </p>
              </div>

              <div style={{background:C.s1,border:`1px solid ${C.border}`,borderRadius:20,padding:32}}>
                <div style={{marginBottom:20}}>
                  <div style={{fontSize:12,fontWeight:600,marginBottom:7,color:"rgba(255,255,255,0.7)"}}>
                    6-digit code
                  </div>
                  <input value={code}
                    onChange={e=>setCode(e.target.value.replace(/\D/g,"").slice(0,6))}
                    onKeyDown={e=>e.key==="Enter"&&handleVerifyMfa()}
                    placeholder="123 456"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    style={{width:"100%",background:C.s2,
                      border:`1.5px solid ${error?C.red:C.border}`,borderRadius:10,
                      padding:"14px 16px",color:C.text,fontSize:22,letterSpacing:6,textAlign:"center",
                      fontFamily:"'DM Mono',monospace",transition:"border-color 0.2s"}}
                    onFocus={e=>e.target.style.borderColor=error?C.red:C.green}
                    onBlur={e=>e.target.style.borderColor=error?C.red:C.border}/>
                  {error && (
                    <div style={{color:C.red,fontSize:12,marginTop:7,display:"flex",alignItems:"center",gap:5}}>
                      <span>⚠</span>{error}
                    </div>
                  )}
                </div>

                <button onClick={handleVerifyMfa} disabled={loading||code.length!==6}
                  style={{width:"100%",background:loading||code.length!==6?"rgba(255,255,255,0.06)":C.green,
                    color:loading||code.length!==6?C.muted:"#000",border:"none",borderRadius:10,
                    padding:"13px",fontSize:14,fontWeight:700,
                    cursor:loading||code.length!==6?"not-allowed":"pointer",
                    fontFamily:"'Instrument Sans',sans-serif",
                    display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:12}}>
                  {loading
                    ? <><span style={{width:14,height:14,border:"2px solid rgba(0,0,0,0.2)",borderTopColor:"#000",
                        borderRadius:"50%",display:"inline-block",animation:"spin 0.7s linear infinite"}}/>Verifying…</>
                    : "Verify →"}
                </button>

                <button type="button" onClick={cancelMfa}
                  style={{width:"100%",background:"transparent",color:C.muted,border:`1px solid ${C.border}`,
                    borderRadius:10,padding:"11px",fontSize:13,fontWeight:600,cursor:"pointer",
                    fontFamily:"'Instrument Sans',sans-serif"}}>
                  ← Back to sign in
                </button>
              </div>
            </>
          ) : (
          <>
          <div style={{textAlign:"center",marginBottom:36}}>
            <div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",
              width:56,height:56,borderRadius:16,background:`linear-gradient(135deg,${C.green},${C.blue})`,
              fontSize:26,marginBottom:18}}>🔐</div>
            <h1 style={{fontFamily:"'Sora',sans-serif",fontSize:28,fontWeight:800,letterSpacing:-1,marginBottom:8}}>
              Welcome back
            </h1>
            <p style={{color:C.muted,fontSize:14,lineHeight:1.6}}>
              Sign in to your <strong style={{color:C.green}}>Media on Auto Pilot</strong> account.
            </p>
          </div>

          <div style={{background:C.s1,border:`1px solid ${C.border}`,borderRadius:20,padding:32}}>
            <div style={{marginBottom:18}}>
              <div style={{fontSize:12,fontWeight:600,marginBottom:7,color:"rgba(255,255,255,0.7)"}}>Email address</div>
              <input value={email} onChange={e=>setEmail(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&handleLogin()}
                placeholder="you@yourbusiness.com" type="email"
                style={{width:"100%",background:C.s2,border:`1.5px solid ${C.border}`,borderRadius:10,
                  padding:"12px 14px",color:C.text,fontSize:14,fontFamily:"'Instrument Sans',sans-serif",
                  transition:"border-color 0.2s"}}
                onFocus={e=>e.target.style.borderColor=C.green}
                onBlur={e=>e.target.style.borderColor=C.border}/>
            </div>
            <div style={{marginBottom:24}}>
              <div style={{fontSize:12,fontWeight:600,marginBottom:7,color:"rgba(255,255,255,0.7)",
                display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                Password
                <button type="button" onClick={()=>onNavigate("forgot-password")} style={{background:"none",border:"none",
                  color:C.green,fontSize:11,cursor:"pointer",fontFamily:"'Instrument Sans',sans-serif"}}>
                  Forgot password?
                </button>
              </div>
              <PasswordInput
                value={password}
                onChange={e=>setPassword(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&handleLogin()}
                placeholder="Your password"
                hasError={!!error}
              />
              {error && <div style={{color:C.red,fontSize:12,marginTop:7,display:"flex",alignItems:"center",gap:5}}>
                <span>⚠</span>{error}
              </div>}
            </div>

            <button onClick={handleLogin} disabled={loading||!email||!password}
              style={{width:"100%",background:loading||!email||!password?"rgba(255,255,255,0.06)":C.green,
                color:loading||!email||!password?C.muted:"#000",border:"none",borderRadius:10,
                padding:"13px",fontSize:14,fontWeight:700,cursor:loading||!email||!password?"not-allowed":"pointer",
                fontFamily:"'Instrument Sans',sans-serif",transition:"all 0.2s",
                display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              {loading
                ? <><span style={{width:14,height:14,border:"2px solid rgba(255,255,255,0.2)",borderTopColor:"#fff",
                    borderRadius:"50%",display:"inline-block",animation:"spin 0.7s linear infinite"}}/>Signing in…</>
                : "Sign In →"}
            </button>
          </div>

          <div style={{textAlign:"center",marginTop:20,fontSize:13,color:C.muted}}>
            Don't have an account?{" "}
            <button onClick={()=>onNavigate("onboarding")} style={{background:"none",border:"none",
              color:C.green,cursor:"pointer",fontWeight:600,fontFamily:"'Instrument Sans',sans-serif",fontSize:13}}>
              Get started →
            </button>
          </div>
          </>
          )}
        </div>
      </div>
      <MinimalFooter onNavigate={onNavigate}/>
    </div>
  );
};
